<template>
  <div class="assign-container">
    <div class="page-content" v-if="getAllMenuCodes.includes('bK2iCPY3')">
      <div class="operation-bar">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          v-if="getAllMenuCodes.includes('4hIzXSYZ')"
          @click="handleCreate"
          >新增</el-button
        >
        <el-button
          type="danger"
          size="mini"
          v-if="getAllMenuCodes.includes('8OSmVELz')"
          @click="handleBatchDelete"
          :disabled="!selectedRows.length || !hasDisabledRows"
          >删除</el-button
        >
        <div class="search-box">
          <span style="margin: 0 10px; color: #fff">大棚编号</span>
          <el-select
            v-model="greenhouseId"
            placeholder="请选择"
            style="width: 160px"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in searchOptions.greenhouseOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>

          <span style="margin: 0 10px; color: #fff">任务分类</span>
          <el-select
            v-model="categoryId"
            placeholder="请选择"
            style="width: 160px"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in taskCategoryOptions"
              :key="item.categoryId"
              :label="item.label"
              :value="item.categoryId"
            />
          </el-select>

          <span style="margin: 0 10px; color: #fff">执行人</span>
          <el-select
            v-model="executorId"
            placeholder="请选择"
            style="width: 160px"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in executorCascaderOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>

          <span style="margin: 0 10px; color: #fff">状态</span>
          <el-select
            v-model="enabled"
            placeholder="请选择"
            style="width: 120px"
            size="mini"
            clearable
          >
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
          <el-button
            icon="el-icon-search"
            style="margin-left: 10px"
            size="mini"
            type="primary"
            @click="handleSearch"
            >查询</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        height="50vh"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" type="index" width="80" align="center">
        </el-table-column>
        <el-table-column
          prop="greenhouseName"
          label="大棚编号"
        ></el-table-column>
        <el-table-column label="任务分类">
          <template slot-scope="scope">
            {{
              scope.row.categoryName ||
              scope.row.taskCategoryName ||
              scope.row.category ||
              "-"
            }}
          </template>
        </el-table-column>
        <el-table-column label="执行人">
          <template slot-scope="scope">
            {{
              scope.row.executorNickName ||
              scope.row.executorName ||
              scope.row.executorUsername ||
              "-"
            }}
          </template>
        </el-table-column>
        <el-table-column label="执行时间">
          <template slot-scope="scope">
            <span>
              {{ scope.row.execDate }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span
              :style="{
                color: scope.row.enabled === 1 ? '#409EFF' : '#909399',
              }"
            >
              {{ scope.row.enabled === 1 ? "启用" : "禁用" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.updateTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="color: #2680dd"
              v-if="getAllMenuCodes.includes('HogAQBgH')"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              style="color: #04ff9f"
              @click="handleView(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <assign-dialog
      :visible.sync="dialogVisible"
      :is-edit="isEdit"
      :edit-data="editData"
      :greenhouse-options="greenhouseOptions"
      :variety-options="varietyOptions"
      :task-category-options="taskCategoryOptions"
      :executor-cascader-options="executorCascaderOptions"
      @success="handleDialogSuccess"
    />

    <!-- 查看详情弹窗 -->
    <assign-dialog
      ref="viewDialog"
      :visible.sync="viewDialogVisible"
      :is-edit="false"
      :view-mode="true"
      :edit-data="viewRow"
      :greenhouse-options="greenhouseOptions"
      :variety-options="varietyOptions"
      :task-category-options="taskCategoryOptions"
      :executor-cascader-options="executorCascaderOptions"
      @success="handleDialogSuccess"
    />
  </div>
</template>

<script>
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";
import dayjs from "dayjs";
import AssignDialog from "./assignDialog.vue";
import { mapGetters } from "vuex";

export default {
  name: "TaskAllocationManagement",
  components: {
    AssignDialog,
  },
  computed: {
    ...mapGetters("user", ["getAllMenuCodes"]),
  },
  data() {
    return {
      tableData: [],
      selectedRows: [],
      greenhouseId: "",
      categoryId: "",
      executorId: "",
      varietyId: "",
      basicStageId: "",
      enabled: "",
      page: 1,
      pageSize: 10,
      totalCount: 0,
      dialogVisible: false,
      isEdit: false,
      editData: {},
      viewDialogVisible: false,
      viewRow: {},
      greenhouseOptions: [],
      varietyOptions: [],
      growthStageOptions: [],
      taskCategoryOptions: [],
      executorCascaderOptions: [],
      hasDisabledRows: false,
      searchOptions: {
        greenhouseOptions: [],
        varietyOptions: [],
      },
    };
  },
  created() {
    this.fetchData();
    this.fetchGreenhouseOptions();
    this.fetchVarietyOptions();
    this.fetchGrowthStageOptions();
    this.fetchTaskCategoryOptions();
    this.fetchExecutorOptions();
    this.fetchSearchOptions();
  },
  methods: {
    // 移除不再需要的方法
    // getFileName
    async fetchData() {
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          greenhouseId: this.greenhouseId,
          categoryId: this.categoryId,
          executorId: this.executorId,
          enabled: this.enabled,
        };
        const res = await axios.post(
          baseUrl + "/api/digital-farming/task/allot/list-page",
          params
        );
        if (res.code === 200) {
          this.tableData = res.data.list || [];
          this.totalCount = parseInt(res.data.totalCount) || 0;
        }
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      // 检查选中的行中是否有禁用状态的行
      this.hasDisabledRows = selection.some((row) => row.enabled === 0);
    },
    handleSearch() {
      this.page = 1;
      this.fetchData();
    },
    handleCreate() {
      this.isEdit = false;
      // 先设置数据，再显示弹窗，避免 watcher 触发问题
      this.editData = {
        id: "",
        greenhouseId: "",
        greenhouseName: "",
        varietyId: "",
        varietyName: "",
        cycleDetailId: "",
        basicStageName: "",
        startDate: "",
        endDate: "",
        canBeforeExec: 1,
        canAfterExec: 1,
        details: [
          {
            taskConfigId: null,
            categoryId: "",
            categoryName: "",
            actions: "",
            pestControl: "",
            stdHumidityTemp: "",
            execStartDate: "",
            execEndDate: "",
            execDateRange: [],
            executorId: "",
            executorUsername: "",
            executorNickName: "",
            guidanceFiles: [],
            pendingFiles: [],
            precautions: "",
          },
        ],
        enabled: 1,
      };
      // 使用 nextTick 确保数据更新完成后再显示弹窗
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    },
    async handleEdit(row) {
      this.isEdit = true;

      try {
        // 调用详情接口获取完整数据
        const res = await axios.post(
          baseUrl + `/api/digital-farming/task/allot/detail-by-id/${row.id}`
        );
        if (res.code === 200) {
          // 先设置数据，再显示弹窗，避免 watcher 触发问题
          this.editData = {
            ...res.data,
            details: res.data.details || [],
          };
          // 使用 nextTick 确保数据更新完成后再显示弹窗
          this.$nextTick(() => {
            this.dialogVisible = true;
          });
        } else {
          this.$message.error(res.message || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        this.$message.error("获取详情失败");
      }
    },
    async handleView(row) {
      try {
        // 调用详情接口获取完整数据，确保农事任务能正确回显
        const res = await axios.post(
          baseUrl + `/api/digital-farming/task/allot/detail-by-id/${row.id}`
        );
        if (res.code === 200) {
          this.viewRow = {
            ...res.data,
            details: res.data.details || [],
          };
          this.viewDialogVisible = true;
        } else {
          this.$message.error(res.message || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        this.$message.error("获取详情失败");
      }
    },
    // 弹窗成功回调
    handleDialogSuccess() {
      this.fetchData();
    },
    async handleBatchDelete() {
      if (!this.selectedRows.length) return;

      // 检查是否只选中了禁用状态的行
      const enabledRows = this.selectedRows.filter((row) => row.enabled === 1);
      if (enabledRows.length > 0) {
        this.$message.warning("只能删除已禁用状态的配置");
        return;
      }

      try {
        await this.$confirm(
          `确认删除选中的 ${this.selectedRows.length} 个配置吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
        const ids = this.selectedRows.map((row) => row.id);
        const res = await axios.post(
          baseUrl + "/api/digital-farming/task/allot/delete-batch",
          ids
        );
        if (res.code === 200) {
          this.$message.success("删除成功");
          this.fetchData();
        }
      } catch (error) {
        if (error !== "cancel") {
          console.error("删除失败:", error);
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
    formatTime(time) {
      if (!time) return "";
      const date = new Date(time);
      return date
        .toLocaleString("zh-CN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .replace(/\//g, "/");
    },
    formatDate(date) {
      if (!date) return "";
      return dayjs(date).format("YYYY-MM-DD");
    },
    // 获取大棚选项
    async fetchGreenhouseOptions() {
      try {
        const res = await axios.get(
          baseUrl + "/api/digital-farming/growth-cycle/selection-greenhouse",
          {
            enabled: 1,
          }
        );
        if (res.code === 200) {
          this.greenhouseOptions = res.data.map((item) => ({
            label: item.name,
            value: item.id,
          }));
        }
      } catch (error) {
        console.error("获取大棚选项失败:", error);
      }
    },
    // 获取草莓品种选项
    async fetchVarietyOptions() {
      try {
        const res = await axios.post(
          baseUrl + "/api/digital-farming/growth-cycle/list-all",
          {
            enabled: 1,
          }
        );
        if (res.code === 200) {
          this.varietyOptions = res.data.map((item) => ({
            label: item.varietyName,
            value: item.id,
            details: item.details,
          }));
        }
      } catch (error) {
        console.error("获取品种选项失败:", error);
      }
    },
    // 获取生长时期选项
    async fetchGrowthStageOptions() {
      this.growthStageOptions = this.$store.state.farm.stageOptions;
    },

    // 获取任务分类选项
    async fetchTaskCategoryOptions() {
      try {
        const res = await axios.get(
          baseUrl + "/api/farming/task-config/selectionV2"
        );
        if (res.code === 200) {
          console.log(res.data);

          this.taskCategoryOptions = res.data
            .filter((item) => item.inner !== 1)
            .map((item) => ({
              label: item.categoryName,
              categoryId: item.categoryId,
              categoryActionsList: item.categoryActionsList,
            }));
        }
      } catch (error) {
        console.error("获取任务分类选项失败:", error);
      }
    },
    // 获取执行人选项
    async fetchExecutorOptions() {
      try {
        const res = await axios.post(baseUrl + "/api/system/users");
        if (res.code === 200) {
          // 过滤出角色为农技员的用户
          const agriTechUsers = res.data.filter(
            (user) =>
              user.roleCodes &&
              user.roleCodes.split(",").includes("greenhouse_admin")
          );

          // 构建级联选择器数据
          this.executorCascaderOptions = agriTechUsers.map((item) => ({
            id: item.id,
            name: `${item.nickName || item.realName || ""} (${item.username})`,
            username: item.username,
            nickName: item.nickName || item.realName,
          }));

          // 保持原有的executorOptions用于兼容
          // this.executorOptions = agriTechUsers.map(item => ({
          //     label: `${item.nickName || item.realName || ''} (${item.username})`,
          //     value: item.id,
          //     username: item.username,
          //     nickName: item.nickName || item.realName
          // }))
        } else {
          console.error("获取用户列表失败:", res.message);
        }
      } catch (error) {
        console.error("获取执行人选项失败:", error);
        this.$message.error("获取执行人列表失败");
      }
    },
    // 获取搜索下拉
    async fetchSearchOptions() {
      this.searchOptions.varietyOptions = this.$store.state.farm.varietyOptions;

      this.searchOptions.greenhouseOptions =
        this.$store.state.farm.greenhouseOptions;
    },
  },
};
</script>

<style scoped lang="less">
.assign-container {
  width: calc(100vw - 20px);

  .page-content {
    box-sizing: border-box;
    background: rgba(0, 11, 47, 0.3);
    padding: 20px;
    border-radius: 4px;
    width: 100%;

    .operation-bar {
      margin-bottom: 20px;
      display: flex;
      align-items: center;

      .search-box {
        margin-left: auto;
        display: flex;
        align-items: center;
      }
    }

    .pagination-container {
      margin-top: 20px;
      text-align: right;
    }

    // 移除不再需要的弹窗相关样式
    // .basic-config, .task-config, .global-settings, .file-upload-container
  }
}
</style>
